import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays, Clock3 } from 'lucide-react';
import { BLOG_POSTS } from '../data/blogs';

export default function Blogs() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Blogs | Sandeep';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <main className="min-h-screen bg-white dark:bg-gray-950 pt-28 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <header className="mb-12">
          <p className="text-blue-600 dark:text-blue-400 text-sm font-medium mb-3 tracking-wide">
            /blogs
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Notes on building and thinking
          </h1>
          <p className="text-lg text-gray-500 dark:text-gray-400 max-w-2xl leading-relaxed">
            Essays on AI, software systems, and the ideas that become clearer when you draw the data.
          </p>
        </header>

        <div className="space-y-6">
          {BLOG_POSTS.map((post) => (
            <article key={post.slug}>
              <Link
                to={`/blogs/${post.slug}`}
                className="group block rounded-3xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-7 md:p-9 hover:border-blue-300 dark:hover:border-blue-700 hover:shadow-xl hover:shadow-blue-100/60 dark:hover:shadow-blue-950/20 transition-all duration-300"
              >
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-600 dark:text-blue-400 mb-4">
                  {post.eyebrow}
                </p>
                <h2 className="font-serif text-3xl md:text-4xl font-semibold leading-tight text-gray-950 dark:text-white group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors">
                  {post.title}
                </h2>
                <p className="mt-4 text-base md:text-lg leading-relaxed text-gray-600 dark:text-gray-300 max-w-3xl">
                  {post.description}
                </p>

                <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-3 text-sm text-gray-500 dark:text-gray-400">
                  <span className="inline-flex items-center gap-2">
                    <CalendarDays className="w-4 h-4" aria-hidden="true" />
                    <time dateTime={post.publishedAt}>{post.displayDate}</time>
                  </span>
                  <span className="inline-flex items-center gap-2">
                    <Clock3 className="w-4 h-4" aria-hidden="true" />
                    {post.readTime}
                  </span>
                </div>

                <div className="mt-7 pt-5 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between gap-4">
                  <div className="flex flex-wrap gap-2">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2.5 py-1 rounded-full text-xs bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-blue-600 dark:text-blue-400 group-hover:gap-2.5 transition-all">
                    Read essay <ArrowRight className="w-4 h-4" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
}
